import { fetchAxios } from "../API/fetchAxios";
import { resolveExtractCategoryId } from "../Pages/Private/Extract/extractFilters";

/**
 * Load AccountBalanceCategory catalog for Extrato filters.
 * IB: GET /v1/ib/accounts/statement-categories → BaaS
 * GET /v1/accounts/{activeId}/statement-categories
 */
export const fetchStatementCategories = async ({ cancelToken } = {}) => {
  const response = await fetchAxios({
    verb: "GET",
    context: "accountStatementCategories",
    cancelToken,
  });
  const payload = response?.data ?? {};
  const rawItems = Array.isArray(payload.items)
    ? payload.items
    : Array.isArray(payload.Items)
      ? payload.Items
      : [];

  return rawItems
    .map((item) => {
      const id = resolveExtractCategoryId(item?.id ?? item?.Id);
      const name = String(item?.name ?? item?.Name ?? "").trim();
      if (id == null || !name) return null;
      return {
        id,
        label: name,
        name,
        icon: item?.icon ?? item?.Icon ?? null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label, "pt-BR", { sensitivity: "base" }));
};
